module.exports = __webpack_public_path__ + "static/media/about.b738fac5.jpg";